import React from "react";
import RoutesApp from "App/Routes";
import Header from "shared/components/Header/Header";
import SidebarContextProvider from "shared/hook/useOpenMenuContext";
import ScrollTop from "shared/components/ScrollTop";

const App = () => (
  <SidebarContextProvider>
    <Header />
    <ScrollTop>
      <RoutesApp />
    </ScrollTop>
  </SidebarContextProvider>
);

export default App;
